import type { ThemeData } from '../models';
import { defaultTheme } from './defaultTheme';

export const toothArmourTheme: ThemeData = {
  ...defaultTheme,
  homeHero: {
    default: {
      media: {
        mobile: {
          src: 'https://cdn.shopify.com/videos/c/o/v/8edbfd25599543229327fbbeb284faf3.mp4',
          height: 272,
          width: 414,
        },
        desktop: {
          src: 'https://cdn.shopify.com/videos/c/o/v/7cf4cf6891ab4a39b1de385b62302a4e.mp4',
          height: 640,
          width: 760,
        },
        alt: 'Shop tooth armour!',
        to: '/products/tooth-armour/',
      },
      content: {
        title: 'Tough teeth use Tooth Armour',
        description: `Supercharge your routine with the ingredients your teeth and mouth love. NEW Tooth Armour Toothpaste Serum. Order NOW`,
        button: {
          text: 'Shop now',
          to: '/products/tooth-armour/',
          width: 'full-width',
          size: 'md',
        },
      },
    },
  },
  navImageBlocks: {
    default: {
      imageBlocks: [
        {
          title: 'iD Stain Whitening Mouthwash',
          link: '/products/id-stain-mouthwash/',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Starter_Bundle_V2-_M.png?v=1784864971',
            alt: 'iD Stain Whitening Mouthwash',
            height: 240,
            width: 366,
          },
        },
        {
          title: 'Tooth Armour',
          link: '/products/tooth-armour',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Nav_-_Tooth_Armour.png?v=1774928763',
            alt: 'Tooth Armour',
            height: 240,
            width: 366,
          },
        },
      ],
    },
    ca: {
      imageBlocks: [
        {
          title: 'Shop Electric Toothbrush',
          link: '/products/electric-toothbrush/',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Electric_Toothbrush.jpg?v=1706071329',
            alt: 'Electric Toothbrush in Pink, Purple and Green',
            height: 240,
            width: 366,
          },
        },
        {
          title: 'Tooth Armour',
          link: '/products/tooth-armour',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Nav_-_Tooth_Armour.png?v=1774928763',
            alt: 'Tooth Armour',
            height: 240,
            width: 366,
          },
        },
      ],
    },
  },
  marqueeData: {
    default: {
      text: `New Tooth Armour Toothpaste Serum. Order NOW`,
      to: `/products/tooth-armour`,
    },
  },
};
